"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOldPriceVisible = exports.getOldPriceTitle = exports.ensureEndsWithColon = void 0;
var _presentationUtils = require("@ori/presentation-utils");
/**
 * Ensures that the given text ends with a colon.
 *
 * @param text
 */
const ensureEndsWithColon = text => {
  const trimmedText = text.trim();
  if (trimmedText.length > 0 && !trimmedText.endsWith(':')) {
    return `${trimmedText}:`;
  }
  return trimmedText;
};
exports.ensureEndsWithColon = ensureEndsWithColon;
const isOldPriceVisible = ({
  cataloguePrice,
  currentPrice
}) => cataloguePrice != null && currentPrice != null && (0, _presentationUtils.parseNumberFromString)(cataloguePrice) > (0, _presentationUtils.parseNumberFromString)(currentPrice);
exports.isOldPriceVisible = isOldPriceVisible;
const getOldPriceTitle = ({
  isBrandPartner,
  translations,
  mrpStatementEnabled
}) => {
  if (mrpStatementEnabled) {
    return translations.mrp;
  }
  return ensureEndsWithColon(isBrandPartner ? translations.cataloguePrice : translations.regularPrice);
};
exports.getOldPriceTitle = getOldPriceTitle;
